import { deliveryNotes } from './delivery-notes-de.i18n';

export const de = {
  deliveryNotes,
};
